/** @jsxImportSource theme-ui */
import BlueDotSvg from 'assets/bluedot-logo.svg';
import InsightsSvg from 'assets/insights.svg';

const InsightsLogo = ({ styles = {} }) => {
  return (
    <div
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        ...styles,
      }}
    >
      <img src={InsightsSvg} alt="" />
      <a
        href="https://bluedot.global"
        target="_blank"
        rel="noopener noreferrer"
        sx={{
          marginTop: '-2px',
          display: 'flex',
        }}
      >
        <img
          src={BlueDotSvg}
          sx={{
            width: '4rem',
            height: '1.44rem',
          }}
          alt=""
        />
      </a>
    </div>
  );
};

export default InsightsLogo;
